import { render, staticRenderFns } from "./Permohonan.vue?vue&type=template&id=55db9538&scoped=true&"
import script from "./Permohonan.vue?vue&type=script&lang=js&"
export * from "./Permohonan.vue?vue&type=script&lang=js&"
import style0 from "./Permohonan.vue?vue&type=style&index=0&id=55db9538&scoped=true&lang=css&"
import style1 from "./Permohonan.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db9538",
  null
  
)

export default component.exports